<template>
  <div class="inlineEditableMultilineText">
    <div
      contenteditable
      :style="styleInput"
      @blur="updateText"
      @focus="onFocus()"
      @click="onFocus()"
      @keyup="hasUnsavedChanges=true"
      :placeholder="placeholder"
      ref="text_input"
      v-html="content()"
    >
    </div>
  </div>
</template>

<script>
// import { mapMutations } from "vuex";

// TODO: Esc to Exit
// TODO: Enter to confirm

export default {
  props: {
    inline: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: "add title here"
    },
    id: {
      type: String
    },
    text: {
      type: String,
      default: ""
    },
    showEditIcon: {
      type: Boolean,
      default: false
    },
    styleInput: {
    },
  },

  watch: {
  },

  components: {
  },

  data() {
    return {
      hasUnsavedChanges: false,
      editModeActive: false,
      showTooltip: false
    };
  },

  // beforeDestroy() {
  //   this.UNSUPPRESS_KEYBOARD_LISTENER();
  //   // this.editModeActive = false;
  // },

  methods: {
    // ...mapMutations("project", [ // TODO: App oder raus und zwar überall
    //   "SUPPRESS_KEYBOARD_LISTENER",
    //   "UNSUPPRESS_KEYBOARD_LISTENER"
    // ]),

    focus(evt) {
      // this.SUPPRESS_KEYBOARD_LISTENER();
    },

    unfocus(evt) {
      // setTimeout(() => {
      //   this.UNSUPPRESS_KEYBOARD_LISTENER();
      // }, 100);
    },
    content () {
      var html = this.text
      /*for (var text of this.greetText) {
        html += '<span>' + text + ' ' + '</span>'
      }*/
      return html
    },
    updateText: function(event) {
      console.log("updateText()", event)
      if (this.hasUnsavedChanges) {
        let text = event.target.innerText
        this.hasUnsavedChanges = false;
        this.$emit("update", text);
      }

      this.$refs.text_input.blur()
    },
    onFocus() {
      console.log('onFocus')
      this.showTooltip = true;
    }
  }
};
</script>

<style>
.inlineEditableMultilineText {
  display: flex;
  word-break: break-all;
  border: 1px solid transparent;
  height: 100%;
  width: 100%;
}
.inlineEditableMultilineText:hover {
  border: 1px solid;
}
</style>
